/* Perky — intro animation controller.
   Enhancement only: the CSS auto-hides the overlay on its own, so the store is
   revealed even if this script never runs. Here we add scroll-lock, a skip
   control (button / click / Esc), and DOM cleanup after the curtain lifts. */
(function () {
  'use strict';

  var intro = document.getElementById('perky-intro');
  if (!intro) return;

  // The inline pre-paint script already hid the overlay when it decided to skip
  // (reduced motion, already-seen this session, or theme editor). Nothing to do.
  if (intro.classList.contains('is-instant-hide')) {
    intro.parentNode && intro.parentNode.removeChild(intro);
    return;
  }

  var root = document.documentElement;
  var prevOverflow = root.style.overflow;
  root.style.overflow = 'hidden';

  var done = false;
  function finish() {
    if (done) return;
    done = true;
    root.style.overflow = prevOverflow;
    if (intro.parentNode) intro.parentNode.removeChild(intro);
  }

  function leave() {
    if (done || intro.classList.contains('is-leaving')) return;
    intro.classList.add('is-leaving');
    // Remove once the leave transition finishes (fallback timer for safety).
    var bail = setTimeout(finish, 900);
    intro.addEventListener('animationend', function () {
      clearTimeout(bail);
      finish();
    }, { once: true });
  }

  // Skip: button, clicking the scene, or Escape.
  var skip = intro.querySelector('.perky-intro__skip');
  if (skip) skip.addEventListener('click', function (e) { e.stopPropagation(); leave(); });
  intro.addEventListener('click', leave);
  function onKey(e) {
    if (e.key === 'Escape') { leave(); document.removeEventListener('keydown', onKey); }
  }
  document.addEventListener('keydown', onKey);

  // Let the full sequence play, then clean up. The curtain keyframe ends at
  // ~3.6s; give it a beat, then remove the node so the store is fully interactive.
  intro.addEventListener('animationend', function (e) {
    if (e.target === intro && e.animationName === 'perkyCurtain') finish();
  });
  setTimeout(finish, 4000);
})();
